import type { Theme } from '@src/app/themes/theme';

const StyleSheet = {
  datePicker: (theme: Theme) => ({
    width: '200px',
    [theme.breakpoints.down('lg')]: {
      width: '170px',
    },
    '& .MuiPickersInputBase-root': {
      border: 'none',
    },
    '& .MuiPickersSectionList-root.MuiPickersInputBase-sectionsContainer': {
      fontSize: '16px',
      padding: 0,
    },
    '& .MuiInputAdornment-root.MuiInputAdornment-positionEnd': {
      '& .MuiSvgIcon-root': {
        width: '18px',
        height: '18px',
      },
    },
  }),
};

export default StyleSheet;
